import * as React from 'react';
import { ValidationSummary } from 'ui';

import styles from './process-panel.scss';

export class ProcessPanel extends React.PureComponent<any, any> {

    public render() {
       const {
          componentId ,
          validation
        } = this.props;             

        return (
          <section id={componentId} className={styles.processPanel}>             
            <ValidationSummary validationError={validation}/>
            <div className="main-grid">
              <div className="row">
                {this.props.children}
              </div>     
            </div>         
          </section>
        );
      }
    }
